import React, { Component } from 'react';
import styled from 'styled-components';
import media from '../../theme/media';
import { fontSans } from '../../theme/config';
import { LinkCustom } from '../../theme/typography';
import { ContainerLarge } from '../../theme/grid';

const FooterContainer = styled.footer`
  font-family: ${fontSans};
  border-top: 1px solid #CED4DA;
  padding: 1rem 0 .5rem 0;
  font-size: 15px;
  width: 100%;
  margin: 1rem auto 2rem auto;
  nav {
    float: right;
  }
  a {
      margin: 0 .5rem;
  }
  ${media.phone`
    width: 100%;
    margin: 0 auto 2rem auto;
    padding: 2rem 0 1rem 0;
  `}
  ${media.small`
    a { margin: 0; }
    nav {
      float: none;
      a {
        margin: 0 1rem 0 0;
      }
    }
  `}
`;

class Footer extends Component {
  render() {
    return (
        <ContainerLarge>
            <FooterContainer>
                <LinkCustom href="/">© Michael McCombie </LinkCustom>
                <nav>
                    {/*<a href="https://spectrum.chat/users/michael" target="_blank" rel="noopener noreferrer">Spectrum</a><Interpunct>·</Interpunct>*/}
                    <LinkCustom href="https://twitter.com/michaelbuilds" target="_blank" rel="noopener noreferrer">Twitter</LinkCustom>
                    <LinkCustom href="https://github.com/michaelmccombie" target="_blank" rel="noopener noreferrer">Github</LinkCustom>
                    <LinkCustom href="https://www.instagram.com/mmccombie/" target="_blank" rel="noopener noreferrer">Instagram</LinkCustom>
                </nav>
            </FooterContainer>
        </ContainerLarge>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// src/components/Footer/Footer.js